import { openVerificationExitPopup } from 'model/flows/verification.model';
import { FunctionalComponent, h } from 'preact';
import { styled } from 'linaria/react';

import { Button } from 'ui/atoms/button';
import { ExitIcon } from 'ui/icons/exit-icon';

type HeaderProps = {
	extra?: any;
};

export const Header: FunctionalComponent<HeaderProps> = (props) => {
	const { extra } = props;

	return (
		<HeaderContainer>
			{extra || <div/>}
			<Button
				name={'open_exit_popup'}
				onClick={() => openVerificationExitPopup()}
				type={'default'}
			>
				<ExitIcon fill={'var(--text-secondary)'}/>
			</Button>
		</HeaderContainer>
	);
};

const HeaderContainer = styled('div')`
	padding: 0 8px 0 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 50px;
	margin-bottom: 16px;
`;
